import { NextHead } from "../../src/landingPage/layouts/LayoutComponents/NextHead";
import { meta } from "../../src/landingPage/datasets/meta";
import { ApplicationPreFill } from "../../src/landingPage/views/Usecases/ApplicationPreFill/ApplicationPreFill";

const ApplicationPreFillPage = () => {
  return (
    <>
      <NextHead
        currentPath="/use-cases/application-prefill"
        title={meta.usecases.applicationprefill.title}
        description={meta.usecases.applicationprefill.description}
      />
      <ApplicationPreFill />
    </>
  );
};

export const getStaticProps = () => {
  return {
    props: {
      wrapper: "MarketingWrapper",
    },
  };
};

export default ApplicationPreFillPage;
